module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$route.name,
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loadding-overlay"
  }, [_c('div', {
    staticClass: "loadding-icn"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-progressbar-pc"
  }, [_c('progressbar', {
    attrs: {
      "current": _vm.mazlicek.step.current,
      "max": _vm.mazlicek.step.max
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-left"
  }, [_c('router-view', {
    attrs: {
      "keep-alive": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app-content-right"
  }, [(_vm.$store.state.mazlicek.step.current < 9) ? _c('div', [_c('right-content-header'), _vm._v(" "), _c('checklist')], 1) : _c('div', [_c('div', {
    staticClass: "final-step-tabs"
  }, [_c('div', {
    staticClass: "final-step-tabs-content"
  }, [_c('div', {
    class: {
      'final-step-tab': true, 'active': _vm.activeTab == 0
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 0
      }
    }
  }, [_vm._v("\n                                Objednávka\n                            ")]), _vm._v(" "), _c('div', {
    class: {
      'final-step-tab': true, 'active': _vm.activeTab == 1
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1
      }
    }
  }, [_vm._v("\n                                Shrnutí\n                            ")])])]), _vm._v(" "), _c('div', [_c('order', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 0),
      expression: "activeTab == 0"
    }]
  }), _vm._v(" "), _c('checklist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 1),
      expression: "activeTab == 1"
    }],
    on: {
      "activeTab": function($event) {
        _vm.activeTab = 0
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "app-progressbar-mobile"
  }, [_c('progressbar', {
    attrs: {
      "current": _vm.mazlicek.step.current,
      "max": _vm.mazlicek.step.max
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115341ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 565
// module chunks = 1